import { useInterval } from '@vueuse/core'
import type { Fn } from '@vueuse/core'
import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'

export interface CountdownTimerControl {
  count: ComputedRef<number>
  start: Fn
  reset: Fn
  isCounting: Readonly<Ref<boolean>>
}

const COUNTDOWN_IN_MS = 1000

export const useCountdownTimer = (countdownTimeInS = 60): CountdownTimerControl => {
  const {
    counter,
    reset,
    pause,
    resume: start,
    isActive,
  } = useInterval(COUNTDOWN_IN_MS, {
    controls: true,
    immediate: false,
    callback: (count) => {
      if (count >= countdownTimeInS) {
        pause()
        reset()
      }
    },
  })
  const count = computed(() => countdownTimeInS - counter.value)

  return {
    count,
    start,
    reset,
    isCounting: isActive,
  }
}
